<section class="reviews-section">
  <div class="reviews-section__head">
    <h2 class="reviews-section__title">{{ "UX_TEXT.REVIEWS.TITLE" | translate }}</h2>
    <button type="button" class="reviews-section__link" (click)="openAllReviews()">
      {{ "UX_TEXT.REVIEWS.ALL_REVIEWS" | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </button>
  </div>

  <div class="reviews-section__score">
    <div class="reviews-section__stars" *ngIf="!isLoading; else scoreSkeleton">
      <ion-icon
        *ngFor="let _ of [1, 2, 3, 4, 5]; let i = index"
        [name]="i < roundedAverageStars ? 'star' : 'star-outline'"
      ></ion-icon>
    </div>
    <span class="reviews-section__value" *ngIf="!isLoading">{{ averageScoreLabel }}</span>
    <span class="reviews-section__count" *ngIf="!isLoading">({{ reviewsCountLabel }})</span>
  </div>
  <ng-template #scoreSkeleton>
    <div class="reviews-section__skeleton reviews-section__skeleton--stars"></div>
    <div class="reviews-section__skeleton reviews-section__skeleton--score"></div>
    <div class="reviews-section__skeleton reviews-section__skeleton--count"></div>
  </ng-template>

  <div class="reviews-section__scroll">
    <article class="reviews-section__card reviews-section__card--skeleton" *ngFor="let _ of skeletonCards" [hidden]="!isLoading">
      <div class="reviews-section__skeleton reviews-section__skeleton--card-stars"></div>
      <div class="reviews-section__skeleton reviews-section__skeleton--line-lg"></div>
      <div class="reviews-section__skeleton reviews-section__skeleton--line-sm"></div>
      <div class="reviews-section__author">
        <div class="reviews-section__skeleton reviews-section__skeleton--avatar"></div>
        <div class="reviews-section__skeleton-stack">
          <div class="reviews-section__skeleton reviews-section__skeleton--name"></div>
          <div class="reviews-section__skeleton reviews-section__skeleton--loc"></div>
        </div>
      </div>
    </article>

    <article class="reviews-section__card" *ngFor="let review of reviews" [hidden]="isLoading">
      <div class="reviews-section__card-stars">
        <ion-icon
          *ngFor="let _ of [1, 2, 3, 4, 5]; let i = index"
          [name]="i < review.stars ? 'star' : 'star-outline'"
        ></ion-icon>
      </div>
      <p class="reviews-section__text">
        {{ review.textKey ? (review.textKey | translate) : getReviewText(review) }}
      </p>
      <div class="reviews-section__author">
        <img class="reviews-section__avatar" [src]="review.avatar" [alt]="review.name" />
        <div>
          <p class="reviews-section__name">{{ review.name }}</p>
          <p class="reviews-section__loc">
            {{ review.locationKey ? (review.locationKey | translate) : getReviewLocation(review) }}
          </p>
        </div>
      </div>
    </article>
  </div>
</section>
